import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { Modal } from 'react-bootstrap';

class MapNameFilterModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {name : ''}

    this.handleOnHide = this.handleOnHide.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleOnHide() {
    this.setState({name : ''});
    this.props.handleOnHide();
  }

  handleSubmit() {
    if(this.state.name) {
      this.props.addClientsFilter({
        value : this.state.name,
        type : 'name',
        label : `name: ${this.state.name}`
      });
      this.props.fetchClients();
    }
    this.handleOnHide();
  }

  handleKeyDown(e) {
    if(e.key == 'Enter') {
      this.handleSubmit();
    }
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.handleOnHide}
        >
        <Modal.Header>
          Enter a name to filter by
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-xs-12'>
              <div className='input-group'>
                <label className='input-group-addon'>Name</label>
                <input
                  className='form-control'
                  onChange={(e) => {this.setState({name : e.target.value})}}
                  value={this.state.name}
                  onKeyDown={this.handleKeyDown}
                />
                <div className='input-group-btn'>
                  <div
                    onClick={this.handleSubmit}
                    className='btn btn-primary'
                    >
                    <i className='fa fa-plus' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default connect(null, Actions)(MapNameFilterModal);



// WEBPACK FOOTER //
// ./src/browser/components/clients/map/map-name-filter-modal.js